import { ref, getCurrentInstance } from 'vue';
import { Picture } from '~/api/topic';

export const PictureActionBarSeoSetup = () => {
    const isLiked = ref(false);

    async function toDataURL(url: string) {
        const blob = await fetch(url).then(res => res.blob());
        return URL.createObjectURL(blob);
    }

    const handleDownloadAction = async (pictureDetail: Picture | undefined) => {
        if (pictureDetail?.pic_origin_url) {
            const a = document.createElement('a');
            a.href = await toDataURL(pictureDetail?.pic_origin_url);
            a.download = `image_${pictureDetail?.pic_id_str}.png`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    };

    const handleLikeAction = () => {};

    return {
        isLiked,

        handleLikeAction,
        handleDownloadAction,
    };
};
